import * as sdkclaro from '@claropay/claro-pay-sdk-v2';
import { getCommissionValues } from "../../components/organisms/GenericForm/utils/getCommissionValues"
import { ClaroSDKService } from "../sdk/ClaroSDKService"
import dummyAppsyncTelcel from "./dummyAppSyncTelcel.json"
import dummyPlans from "./dummyPlansAmigoSinLimite.json"
import dummyIntTiempoPre from "./dummyInternetTiempoPrepago.json"

let lastControllerGetCommissions = null;

export const ClaroPayApi = {
    async getCommissionInfo(
        serviceId,
        merchantId,
        amount,
        isClaroPay,
        cardId,
        sdkVersion,
        isClaroPartner,
        trackId,
        userInfo,
        referenceMsisdn,
        isContainerTelcel,
        bundleParamsFromUrl
    ) {
        // Si existe una solicitud anterior, la cancelamos
        if (lastControllerGetCommissions) {
            lastControllerGetCommissions.abort('Previous request aborted');
        }

        // Crear un nuevo AbortController para la nueva solicitud
        lastControllerGetCommissions = new AbortController();
        const { signal } = lastControllerGetCommissions;
        

        const {cpso, cpbv, bundleId } = bundleParamsFromUrl
        return new Promise(async(resolve, reject) => {
            try {
                const url =  "https://uatapi.claropay.com/uat-CalculadoraComisiones/commissions/calculateCommission";
                
                const apikey = !isContainerTelcel
                    ? "hHdYcPs4nK3GC14MkFFZp5Uw4GnQ4noa3dlnvGvl"
                    : "B0rTJiv1Mtwb2KtBhueuIcUqXJWXQzf2Opc38uhp";

                const appVersion = (sdkVersion)?"3.14": "2.0.148";
                const data = {
                    serviceId: serviceId,
                    merchantId: merchantId,
                    amount: amount,
                    isClaroPay : isClaroPay,
                    cardId: cardId,
                    appVersion : appVersion,
                    isClaroPartner : isClaroPartner,
                    referenceMsisdn : referenceMsisdn ? referenceMsisdn : userInfo.msisdn ? userInfo.msisdn.slice(-10) : null,
                };

                const { access_token } =  await ClaroSDKService.getFullToken();

                ClaroSDKService.postTrack(trackId, 'CCM01-REQUEST', '', {...data, url}, userInfo)
                fetch(url, {
                    signal,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'x-api-key': apikey,
                        'cp-bi' : bundleId || "",
                        'cp-so' : cpso || "" ,
                        'cp-bv' : cpbv || "",
                        'Authorization' : access_token ? `Bearer ${access_token}` : ""
                    },
                    body: JSON.stringify(data)
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(resp) {
                    ClaroSDKService.postTrack(trackId, 'CCM02-RESPONSE', resp, {...data, url}, userInfo)
                    if(resp.responseStatus.desc == "Successful"){
                        console.log(resp.data.serviceCommission, "result commissions success");
                        const result = getCommissionValues(resp.data.serviceCommission);
                        return resolve(result);
                    } else {
                        return reject(resp)
                    }
                })
                .catch(function(err) {
                    console.log(err);
                    return reject(err)
                });
            } catch (error) {
                console.log(error, "commisionValues catch");
                return reject(error)
            }
        })
    },

    async getPlans(serviceId, planType, isContainerTelcel){
        return new Promise((resolve, reject) => {
            try {
                const url =  `https://uatapi.claropay.com/uat-appservices/plans/getPlans?idCategory=${planType}&idService=${serviceId}`;

                const apikey = !isContainerTelcel
                    ? "iSHknbS3OT4TXOqFSGthC5ku77lfjqjeaCSP2ihG"
                    : "V0rdJiv1Mtwb27tBhueuIcUqXJWXQzf2OPC38uhe";

                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'x-api-key': apikey
                    },
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    console.log("Succes plans telcel");
                    return resolve(data.data[0]);
                })
                .catch(function(err) {
                    console.error(err);
                });
            } catch (error) {
                console.log(error, "commisionValues catch");
            }
        })

        // return new Promise(resolve => {
        //     setTimeout(() => {
        //         resolve(dummyIntTiempoPre.data[0]);
        //     }, 1000);
        // })
    },
    
    async getTelcelLineInformationService(line, claroId, perfilTelcel){
        return new Promise((resolve, reject) => {
            try {
                fetch(
                    `${process.env.REACT_APP_MIDDLEWARE_TELCEL_URL_API}/?claroid=${claroId}&msisdn=${line}&perfilTelcel=${perfilTelcel}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': '*/*',
                            'x-api-key': process.env.REACT_APP_MIDDLEWARE_TELCEL_API_KEY_NAME
                        },
                    }
                )
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    // data.data = {
                    //     ...data.data,
                    //     postpago: false,
                    //     prepago: true
                    // }
                    console.log("Midelware telcel success");
                    return resolve(data.data);
                })
                .catch(function(err) {
                    console.log(err , "Midelware telcel error");
                });
            } catch (error) {
                console.log(error, "Midelware telcel catch");
            }
        })
    },

    async getScheduleTelcelBillPaymentContractService(
        bank,
        maximumAmount,
        minimumAmount,
        msisdn,
        periodicity,
        product,
        providerService
    ) {
        let url = process.env.REACT_APP_DOMICILIATION_API_URL;
        url += `/getTemplateTermsConditions`
        url += `?bank=${bank}`;
        url += `&maximumAmount=${maximumAmount}`;
        url += `&minimumAmount=${minimumAmount}`;
        url += `&msisdn=${msisdn}`;
        url += `&periodicity=${periodicity}`;
        url += `&product=${product}`;
        url += `&providerService=${providerService}`;

        return new Promise((resolve, reject) => {
            try {
                fetch(url, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': '*/*',
                            'x-api-key': process.env.REACT_APP_DOMICILIATION_API_KEY
                        },
                    }
                )
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    console.log("Schedule bill payment telcel success");
                    return resolve(data.data);
                })
                .catch(function(err) {
                    console.log(err , "Schedule bill payment telcel error");
                });
            } catch (error) {
                console.log(error, "Schedule bill payment telcel catch");
            }
        })
    },

    async getAppSyncApi(bundleVersion) {
        const {
            REACT_APP_APPSYNC_BUNDLE_VERSION_CLARO_PAY,
            REACT_APP_APPSYNC_BUNDLE_ID_CLARO_PAY,
            REACT_APP_APPSYNC_COUNTRY_ID,
            REACT_APP_APPSYNC_BANK_ID
        } = process.env
        bundleVersion = bundleVersion 
            ? bundleVersion 
            : REACT_APP_APPSYNC_BUNDLE_VERSION_CLARO_PAY;
        return new Promise((resolve, reject) => {
          try {
            let url = `${process.env.REACT_APP_SYNC_URL}`;
                url+= `/appsync/init?bundleID=${REACT_APP_APPSYNC_BUNDLE_ID_CLARO_PAY}`;
                url+= `&countryId=${REACT_APP_APPSYNC_COUNTRY_ID}`;
                url+= `&bankId=${REACT_APP_APPSYNC_BANK_ID}`;
                url+= `&bundleVersion=${bundleVersion}`;
            fetch(url, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "x-api-key": process.env.REACT_APP_SYNC_API_KEY
              },
            })
              .then(function (response) {
                return response.json();
              })
              .then(function (resp) {
                console.log(resp, "response appsync success ");
                resolve(resp);
              })
              .catch(function (error) {
                console.log(error, "appsync error");
              });
          } catch (error) {
            console.log(error, "appsync catch");
          }
        });
      },

    async getAppSyncTelcelApi(bundleVersion) {
        bundleVersion = bundleVersion 
            ? bundleVersion 
            : process.env.REACT_APP_APPSYNC_BUNDLE_VERSION;
            
        return new Promise((resolve, reject) => {
            try {
                let url = `${process.env.REACT_APP_SDK_API_APPSYNC}`;
                    url+= `/appsync/init?bundleID=${process.env.REACT_APP_APPSYNC_BUNDLE_ID}`;
                    url+= `&countryId=${process.env.REACT_APP_APPSYNC_COUNTRY_ID}`;
                    url+= `&bankId=${process.env.REACT_APP_APPSYNC_BANK_ID}`;
                    url+= `&bundleVersion=${bundleVersion}`;

                fetch(url, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        'Accept': "application/json",
                        'x-api-key': process.env.REACT_APP_SDK_API_KEY_APPSYNC
                    },
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resp) {
                    console.log("response appsync telcel success ");
                    resolve(resp);
                })
                .catch(function (error) {
                    console.log(error, "appsync telcel error");
                });
            } catch (error) {
            console.log(error, "appsync telcel catch");
            }
        });

        // return new Promise( resolve => {
        //     setTimeout(() => {
        //         console.log(dummyAppsyncTelcel)
        //         resolve(dummyAppsyncTelcel)
        //     }, 1000);
        // })
    },

    async deleteAllCardsApi(userInfo, fullToken) {
        return new Promise((resolve) => {
            try {
                const data = {
                    appVersion: "3.4.100",
                    externalId: "38888a9d-5d9e-4392-a057-829ee92test11",
                    latitude: "0.0",
                    longitude: "0.0",
                    msisdn: userInfo.msisdn,
                    claroId: userInfo.username
                };

                fetch(process.env.REACT_APP_DELETE_ALL_CARDS_URL, {
                    method: 'POST',
                    headers: {
                        'Authorization': `${fullToken.token_type} ${fullToken.access_token}`,
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'x-api-key': process.env.REACT_APP_DELETE_ALL_CARDS_API_KEY
                    },
                    body: JSON.stringify(data)
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(resp) {
                    console.log('Delete all cards success:', resp);
                    resolve(resp);
                })
                .catch(function(err) {
                    console.error('Delete all cards error:', err);
                    resolve({success: false});
                });
            } catch (error) {
                console.log(error, 'Delete all cards catch')
                resolve({success: false});
            }  
        })
         
    },
    async getBalances(reference, serviceId, endPointData) {  
        const {url, apiKey, needsDelay} = endPointData  
        try {
            const response = await fetch(
                `${url}/serviceId/${serviceId}/contract/${reference}`, {
                method: 'GET',
                headers: { 
                    "x-api-key": apiKey,
                    'Content-Type': "application/json",
                    "Accept": "application/json",
                    "Needs-Delay": needsDelay
                }
            });
            if (response.ok) {
                return await response.json();
            } else {
                return response;
            }
        } catch (error) {
            return error
        }
    },
    async getPhoneProfile(msisdn) {  
        try {
            const response = await fetch(
                `${process.env.REACT_APP_GET_PHONE_PROFILE_URL}/?msisdn=${msisdn}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                    'x-api-key': process.env.REACT_APP_MIDDLEWARE_TELCEL_API_KEY_NAME
                },
            });
            if (response.ok) {
                return await response.json();
            } else {
                return response;
            }
        } catch (error) {
            return error
        }
    },
}
    

